export default __webpack_public_path__ + "static/media/ic_alert_warning.78d87d53.svg";